import React from 'react';
import LinkAndAnchor from '../LinkAndAnchor';
import getStandsBreadcrumbs from '../Stands/getBreadcrumbs';

const Breadcrumbs = ({
  marketName, marketId, standName, standId,
}) => (
  [
    ...getStandsBreadcrumbs({ marketName, marketId }),
    <LinkAndAnchor
      route="stand"
      params={{ marketId, standId }}
    >
      {standName}
    </LinkAndAnchor>,
  ]
);

export default Breadcrumbs;
